module.exports = __webpack_public_path__ + "img/bicom_logo_white.b33bd2dc.png";